import { useEffect, useRef } from "react";
//not move CR 
const useAutoScroll = (targetRef, options = {}) => {
  // const { speed = 0.05, interval = 30, onAfterScroll, enabled = true } = options;
  // const directionRef = useRef(1);
  // const userInteractingRef = useRef(false);
  // const timerRef = useRef(null);

  // useEffect(() => {
  //   if (!enabled)
  //     return;
  //   const tick = () => {
  //     const ref = targetRef.current;
  //     if (!ref)
  //       return;
  //     if (userInteractingRef.current) {
  //       return;
  //     }
  //     const { scrollTop, scrollHeight, clientHeight } = ref;
  //     let next = scrollTop + directionRef.current * speed;
  //     if ((scrollHeight - clientHeight) <= 0)
  //       return;
  //     if (next >= (scrollHeight - clientHeight)) {
  //       next = (scrollHeight - clientHeight);
  //       directionRef.current = -1;
  //     } else if (next <= 0) {
  //       next = 0;
  //       directionRef.current = 1;
  //     }
  //     ref.scrollTop = next;
  //     if (typeof onAfterScroll === "function") {
  //       onAfterScroll(ref);
  //     }
  //   };

  //   timerRef.current = setInterval(tick, interval);

  //   return () => {
  //     if (timerRef.current) {
  //       clearInterval(timerRef.current);
  //       timerRef.current = null;
  //     }
  //   };
  // }, [targetRef, speed, interval, onAfterScroll, enabled]);

  // // האזנה לאינטראקציה של המשתמש כדי לעצור את התנועה
  // useEffect(() => {
  //   const ref = targetRef.current;
  //   if (!ref)
  //     return;
  //   const handleStart = () => {
  //     // כל דבר שמראה שהמשתמש "עסוק" באיזור – עוצר את האוטו־סקרול
  //     userInteractingRef.current = true;
  //   };

  //   const handleEnd = () => {
  //     userInteractingRef.current = false;
  //   };

  //   // ✨ עצירה בגלילה / נגיעה / לחיצה
  //   ref.addEventListener("wheel", handleStart, { passive: true });
  //   ref.addEventListener("touchstart", handleStart, { passive: true });
  //   ref.addEventListener("mousedown", handleStart);
  //   ref.addEventListener("pointerdown", handleStart);
  //   ref.addEventListener("mouseenter", handleStart);
  //   ref.addEventListener("touchend", handleEnd);
  //   ref.addEventListener("mouseup", handleEnd);
  //   ref.addEventListener("pointerup", handleEnd);
  //   ref.addEventListener("mouseleave", handleEnd);

  //   return () => {
  //     ref.removeEventListener("wheel", handleStart);
  //     ref.removeEventListener("touchstart", handleStart);
  //     ref.removeEventListener("mousedown", handleStart);
  //     ref.removeEventListener("pointerdown", handleStart);
  //     ref.removeEventListener("mouseenter", handleStart);
  //     ref.removeEventListener("touchend", handleEnd);
  //     ref.removeEventListener("mouseup", handleEnd);
  //     ref.removeEventListener("pointerup", handleEnd);
  //     ref.removeEventListener("mouseleave", handleEnd);
  //   };
  // }, [targetRef]);
};

export default useAutoScroll;
